/* Pix on Puzzles: cart "Shipping & delivery" panel (assets/pix-cart-extras.js).
   Works on the cart page and in the cart drawer. The markup comes from snippets/pix-cart-ship.liquid;
   panels that appear later (the drawer filling up) are picked up automatically. */
(function () {
  if (window.__pixCartExtras) return; window.__pixCartExtras = 1;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k) || ''; localStorage.setItem(k, v); } catch (e) { return ''; } }

  /* ---------- dates: business days, skipping weekends and USPS holidays ---------- */
  var HOLIDAYS = ['2026-11-11', '2026-11-26', '2026-12-25', '2027-01-01', '2027-01-18', '2027-02-15', '2027-05-31', '2027-06-18',
                  '2027-07-05', '2027-09-06', '2027-10-11', '2027-11-11', '2027-11-25', '2027-12-24', '2027-12-31'];
  function key(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function workday(d) { var w = d.getDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(key(d)) < 0; }
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (workday(d)) n--; } return d; }
  function today() {      /* the date in Missouri, where puzzles ship from */
    try {
      var o = {}; new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(new Date()).forEach(function (x) { o[x.type] = +x.value; });
      return new Date(o.year, o.month - 1, o.day);
    } catch (e) { var t = new Date(); return new Date(t.getFullYear(), t.getMonth(), t.getDate()); }
  }
  function fmt(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function range(a, b) { return fmt(a) + ' – ' + fmt(b); }
  function transit(r) {      /* days in the mail, earliest to latest: the carrier's range when it gives one, otherwise by service */
    var d = r && r.delivery_days, lo = d && +d[0], hi = d && +d[d.length - 1];
    if (lo > 0 && hi > lo) return [lo, hi];
    var n = String(r && (r.presentment_name || r.name) || '');
    if (/express/i.test(n)) return [1, 2];
    if (/priority/i.test(n)) return [1, 3];
    return [2, 5];
  }

  /* ---------- shipping rates (the same ones checkout uses) ---------- */
  /* state from the first 3 digits of a ZIP: Shopify's rate lookup wants it for US addresses */
  var Z = [[5,5,'NY'],[10,27,'MA'],[28,29,'RI'],[30,38,'NH'],[39,49,'ME'],[50,54,'VT'],[55,55,'MA'],[56,59,'VT'],[60,69,'CT'],[70,89,'NJ'],
    [100,149,'NY'],[150,196,'PA'],[197,199,'DE'],[200,200,'DC'],[201,201,'VA'],[202,205,'DC'],[206,219,'MD'],[220,246,'VA'],[247,268,'WV'],
    [270,289,'NC'],[290,299,'SC'],[300,319,'GA'],[320,339,'FL'],[341,349,'FL'],[350,369,'AL'],[370,385,'TN'],[386,397,'MS'],[398,399,'GA'],
    [400,427,'KY'],[430,459,'OH'],[460,479,'IN'],[480,499,'MI'],[500,528,'IA'],[530,549,'WI'],[550,567,'MN'],[569,569,'DC'],[570,577,'SD'],
    [580,588,'ND'],[590,599,'MT'],[600,629,'IL'],[630,658,'MO'],[660,679,'KS'],[680,693,'NE'],[700,714,'LA'],[716,729,'AR'],[730,732,'OK'],
    [733,733,'TX'],[734,749,'OK'],[750,799,'TX'],[800,816,'CO'],[820,831,'WY'],[832,838,'ID'],[840,847,'UT'],[850,865,'AZ'],[870,884,'NM'],
    [885,885,'TX'],[889,898,'NV'],[900,961,'CA'],[967,968,'HI'],[970,979,'OR'],[980,994,'WA'],[995,999,'AK']];
  function stateOf(zip) { var p = +zip.slice(0, 3); for (var i = 0; i < Z.length; i++) if (p >= Z[i][0] && p <= Z[i][1]) return Z[i][2]; return ''; }
  function qs(zip) {
    var st = stateOf(zip);
    return 'shipping_address%5Bzip%5D=' + encodeURIComponent(zip) + '&shipping_address%5Bcountry%5D=United%20States' +
      (st ? '&shipping_address%5Bprovince%5D=' + encodeURIComponent(st) : '');
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function get(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json' } }, opts || {}))
      .then(function (r) { return r.text().then(function (t) { var d = null; try { d = JSON.parse(t); } catch (e) {} return { ok: r.ok, status: r.status, data: d }; }); });
  }
  function fetchRates(zip) {
    var q = qs(zip);
    return get(ROOT + 'cart/prepare_shipping_rates.json?' + q, { method: 'POST' }).then(function (p) {
      if (!p.ok && p.status !== 202) {
        if (p.status === 404) return get(ROOT + 'cart/shipping_rates.json?' + q).then(function (s) {
          if (s.ok && s.data && s.data.shipping_rates) return s.data.shipping_rates; throw { msg: s.data };
        });
        throw { msg: p.data };
      }
      var tries = 0;
      return (function poll() {
        return get(ROOT + 'cart/async_shipping_rates.json?' + q).then(function (a) {
          if (a.ok && a.data && a.data.shipping_rates) return a.data.shipping_rates;
          if (!a.ok && a.status !== 202) throw { msg: a.data };
          if (++tries > 24) throw { msg: null };
          return wait(500).then(poll);
        });
      })();
    });
  }
  function cleanName(n) { return String(n || 'Shipping').replace(/^usps\s*/i, 'USPS ').replace(/\s+/g, ' ').trim(); }

  /* ---------- the Shipping & delivery panel ---------- */
  function initShip(el) {
    if (el.__pxs) return; el.__pxs = 1;
    var SHIP = +el.getAttribute('data-ship-days') || 5, FREE = +el.getAttribute('data-free-over') || 0;
    var $ = function (s) { return el.querySelector(s); };
    var form = $('[data-pxs-form]'), zipIn = $('[data-pxs-zipin]'), go = $('[data-pxs-go]'), out = $('[data-pxs-out]');
    var shipV = $('[data-pxs-shipv]'), etaV = $('[data-pxs-eta]'), freeP = $('[data-pxs-free]');
    var lastZip = '', runId = 0, timer = 0;

    function eta(t) { var s = addBiz(today(), SHIP); return [addBiz(s, t[0]), addBiz(s, t[1])]; }
    function showEta(t) { var e = eta(t || [2, 5]); if (etaV) etaV.textContent = range(e[0], e[1]); }
    function money(c) { return '$' + (c / 100).toFixed(2); }
    function showFree() {      /* the progress bar toward free shipping */
      if (!freeP) return;
      if (!FREE) { freeP.hidden = true; return; }
      var tot = +el.getAttribute('data-total') || 0, pct = Math.max(0, Math.min(100, Math.round(tot / FREE * 100)));
      var t = freeP.querySelector('[data-pxs-free-t]'), bar = freeP.querySelector('[data-pxs-bar]');
      freeP.hidden = false;
      freeP.classList.toggle('is-on', tot >= FREE);
      if (t) t.textContent = tot >= FREE ? 'You’ve got free shipping!' : 'Add ' + money(FREE - tot) + ' more for free shipping';
      if (bar) { bar.setAttribute('aria-valuenow', pct); bar.firstElementChild.style.width = pct + '%'; }
    }
    function say(t, err) { out.innerHTML = '<p class="pxs-msg' + (err ? ' is-err' : '') + '">' + esc(t) + '</p>'; }
    function setShip(t, free) { shipV.textContent = t; shipV.className = 'pxs-v' + (free ? ' is-free' : ''); }
    function estimate(zip, quiet) {
      var id = ++runId; lastZip = zip; go.disabled = true; go.textContent = '…';
      if (!quiet) say('Checking shipping to ' + zip + '…');
      return fetchRates(zip).then(function (list) {
        if (id !== runId) return;
        list = (list || []).filter(function (r) { return r && r.price != null; })
          .sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
        if (!list.length) { setShip('At checkout'); say('We couldn’t find a rate for ' + zip + '. You’ll see your shipping options at checkout.'); showEta(); return; }
        var h = '<ul class="pxs-rates">';
        list.slice(0, 3).forEach(function (r) {
          var p = parseFloat(r.price), e = eta(transit(r));
          h += '<li><b>' + esc(cleanName(r.presentment_name || r.name)) + '</b><span class="p' + (p === 0 ? ' is-free' : '') + '">' +
               (p === 0 ? 'FREE' : '$' + p.toFixed(2)) + '</span><small>Arrives ' + esc(range(e[0], e[1])) + '</small></li>';
        });
        out.innerHTML = h + '</ul><p class="pxs-msg">Estimate for ' + esc(zip) + '. You&rsquo;ll choose your option at checkout.</p>';
        var c = parseFloat(list[0].price);
        setShip(c === 0 ? 'FREE' : 'from $' + c.toFixed(2), c === 0);
        showEta(transit(list[0]));
        store('pix_zip', zip);
      }).catch(function (e) {
        if (id !== runId) return;
        var m = e && e.msg, bad = m && (m.zip || m.province || m.country);
        setShip('At checkout');
        say(bad ? 'That ZIP code doesn’t look right. Please check it and try again.'
                : 'We couldn’t get an estimate right now. You’ll see your shipping options at checkout.', true);
      }).then(function () { if (id === runId) { go.disabled = false; go.textContent = 'Estimate'; } });
    }
    function submit() {
      var zip = (zipIn.value || '').replace(/\s+/g, '');
      if (!/^\d{5}(-?\d{4})?$/.test(zip)) { say('Please enter a 5-digit US ZIP code.', true); zipIn.focus(); return; }
      estimate(zip.slice(0, 5));
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); submit(); });
    zipIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); submit(); } });

    /* the cart changed (quantity, discount): the theme refreshes data-total; refresh the nudge and the rates */
    function changed() { showFree(); if (lastZip) { clearTimeout(timer); timer = setTimeout(function () { estimate(lastZip, true); }, 400); } }
    new MutationObserver(changed).observe(el, { attributes: true, attributeFilter: ['data-total'] });

    showEta(); showFree();
    var saved = store('pix_zip');
    if (/^\d{5}$/.test(saved)) { zipIn.value = saved; estimate(saved, true); }
  }

  /* ---------- start, and pick up panels the drawer adds later ---------- */
  function scan() {
    document.querySelectorAll('.pxs[data-pxs]').forEach(initShip);
  }
  scan();
  var queued = 0;
  new MutationObserver(function () { if (!queued) { queued = 1; requestAnimationFrame(function () { queued = 0; scan(); }); } })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
